import { useState, useEffect, useRef, Fragment } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import styles from "../../assets/scss/Navbar.module.scss";
import ResetPassword from "../resetPassword/ResetPassword";
import { isEmpty } from "lodash";
import logo from "../../assets/images/logo.png";
import mini_logo from "../../assets/images/mini-logo.png";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import Logout from "../Logout/Logout";
import { useDispatch, useSelector } from "react-redux";
import { twoDigitDecimal } from "../../helpers/commonFunction";
import ToastAlert from '../../components/utils/ToastAlert';
import { isAdmin, isDealer, isDealerUser } from '../../helpers/commonFunction';
import ContactDetails from "../ContactDetails/ContactDetails";


function Header() {
  const [openNotification, setOpenNotification] = useState(true);
  const [toggle, setToggle] = useState(false);
  const [navIsOpen, setNavIsOpen] = useState(null);
  const [logoutModal, setLogoutModal] = useState(false);
  const [resetModal, setResetModal] = useState(false);
  let dropRef = useRef();
  const { tokenData, tokenError, defaultCurrency } = useSelector((state) => state.auth);
  const { UserPanelAccessList, getUserPanelAccessError } = useSelector(state => state.generic);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropRef.current && !dropRef.current.contains(event.target)) {
        setOpenNotification(true); // close notification
        setLogoutModal(false); // close logout
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const accessMenuFun = (id) => {
    return (
      Array.isArray(UserPanelAccessList) &&
      UserPanelAccessList.some((item) => item?.ID == id && item?.STATUS)
    );
  };

  useEffect(() => {
    if (getUserPanelAccessError) {
      ToastAlert({ type: "error", text: getUserPanelAccessError });
    }

    if (tokenError) {
      ToastAlert({ type: "error", text: tokenError });
    }
  }, [getUserPanelAccessError, tokenError]);

  const navItems = [
    {
      name: "Dashboard",
      path: "/",
      icon: "fa fa-dashboard",
    },
    (isAdmin(tokenData) || (accessMenuFun(1) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
      name: "Admin",
      path: "/",
      icon: "fas fa-user-shield",
      children: [
        isAdmin(tokenData) &&
        {
          name: "Dealer",
          path: "admin/dealer",
          icon: "fas fa-user-tie",
        },
        (isAdmin(tokenData) || (accessMenuFun(1) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
          name: "User",
          path: "admin/user",
          icon: "fas fa-users",
        },
        isAdmin(tokenData) && {
          name: "Page Access",
          path: "admin/page-access",
          icon: "fas fa-user-lock",
        },
        isAdmin(tokenData) && {
          name: "Plan Price Mapping",
          path: "admin/plan-price-mapping",
          icon: "fas fa-link",
        },
        isAdmin(tokenData) && {
          name: "Fund Management",
          path: "admin/fund-management",
          icon: "fas fa-hand-holding-usd",
        },
      ].filter(Boolean),
    },
    (isAdmin(tokenData) || (accessMenuFun(2) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
      name: "Inventory",
      path: "/",
      icon: "fas fa-random",
      children: [
        isAdmin(tokenData) && {
          name: "Purchase SIM",
          path: "inventory/purchase-sim",
          icon: "ri-shopping-cart-fill fs-6",
        },
        (isAdmin(tokenData) || (accessMenuFun(20) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
          name: "Inventory Transfer",
          path: "/inventory/inventory-transfer",
          icon: "fas fa-exchange-alt",
        },
        (isAdmin(tokenData) || (accessMenuFun(2) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
          name: "SIM List",
          path: "/inventory/sim-list",
          icon: "ri-sim-card-line fs-6",
        },

        isAdmin(tokenData) && {
          name: "Purchase SIM List",
          path: "/inventory/purchase-sim-list",
          icon: "ri-sim-card-2-fill fs-6",
        },
      ].filter(Boolean),
    },
    (isAdmin(tokenData) || ((accessMenuFun(3) || accessMenuFun(4)) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
      name: "Activation",
      path: "/",
      icon: "fa-solid fa-sim-card",
      children: [
        (isAdmin(tokenData) || (accessMenuFun(3) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
          name: "SIM Activation",
          path: "activation/sim-activation",
          icon: "fas fa-sim-card",
        },
        (isAdmin(tokenData) || (accessMenuFun(4) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
          name: "Bulk Activation",
          path: "activation/bulk-activation",
          icon: "fas fa-layer-group",
        },
      ].filter(Boolean),
    },
    (isAdmin(tokenData) || ((accessMenuFun(5) || accessMenuFun(6)) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
      name: "Recharge",
      path: "/",
      icon: "fas fa-bolt",
      children: [
        (isAdmin(tokenData) || (accessMenuFun(5) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
          name: "Recharge",
          path: "/recharge/single-recharge",
          icon: "fas fa-bolt",
        },
        (isAdmin(tokenData) || (accessMenuFun(6) && (isDealer(tokenData) || isDealerUser(tokenData)))) && {
          name: "Bulk Recharge",
          path: "/recharge/bulk-recharge",
          icon: "fas fa-layer-group",
        },
      ].filter(Boolean),
    },
    (accessMenuFun(7) || accessMenuFun(8) || accessMenuFun(9) || accessMenuFun(10) || accessMenuFun(11) || accessMenuFun(12) || accessMenuFun(13) || accessMenuFun(14)) && {
      name: "Reports",
      path: "/",
      icon: "fas fa-chart-bar",
      children: [
        (accessMenuFun(7)) && {
          name: "Activation Report",
          path: "/reports/activation-report",
          icon: "fas fa-check-circle",
        },
        (accessMenuFun(8)) && {
          name: "Recharge Report",
          path: "/reports/recharge-report",
          icon: "fas fa-wallet",
        },
        (accessMenuFun(9)) && {
          name: "MSISDN Swap Report",
          path: "/reports/msisdn-swap-report",
          icon: "fas fa-exchange-alt",
        },
        (accessMenuFun(10)) && {
          name: "SIM Swap Report",
          path: "/reports/sim-swap-report",
          icon: "fas fa-sim-card",
        },
        (accessMenuFun(11)) && {
          name: "Activation Batch Report",
          path: "/reports/batch-activation-report",
          icon: "fas fa-layer-group",
        },
        (accessMenuFun(12)) && {
          name: "Recharge Batch Report",
          path: "/reports/batch-recharge-report",
          icon: "fas fa-layer-group",
        },
        (accessMenuFun(13)) && {
          name: "Wi-Fi Batch Report",
          path: "/reports/wifi-batch-report",
          icon: "fas fa-wifi",
        },
        (accessMenuFun(14)) && {
          name: "Txn Ledger Report",
          path: "/reports/ledger-report",
          icon: "fas fa-exchange-alt",
        },
        (isAdmin(tokenData)) && {
          name: "Fund Report",
          path: "/reports/fund-report",
          icon: "fas fa-file-invoice-dollar",
        },
      ].filter(Boolean),
    },
    (accessMenuFun(15) || accessMenuFun(16)) && {
      name: "Wi-Fi Calling",
      path: "/",
      icon: "fas fa-phone-volume",
      children: [
        (accessMenuFun(15)) && {
          name: "Wi-Fi Activation",
          path: "wifi/wifi-activation",
          icon: "fas fa-wifi",
        },
        (accessMenuFun(16)) && {
          name: "Cancel Wi-Fi",
          path: "wifi/cancel-wifi",
          icon: "fas fa-ban",
        },
      ].filter(Boolean),
    },
    (accessMenuFun(17) || accessMenuFun(18)) && {
      name: "Swap",
      path: "/",
      icon: "fas fa-retweet",
      children: [
        // (accessMenuFun(17)) && {
        //   name: "MSISDN Swap",
        //   path: "swap/mdn-swap",
        //   icon: "fas fa-exchange-alt",
        // },
        (accessMenuFun(18)) && {
          name: "SIM Swap",
          path: "swap/sim-swap",
          icon: "fas fa-sync-alt",
        },
      ].filter(Boolean),
    },
    (accessMenuFun(19)) && {
      name: "Check Status",
      path: "/",
      icon: "fas fa-tasks",
      children: [
        (accessMenuFun(19)) && {
          name: "Check Status",
          path: "checkstatus/check-status",
          icon: "fas fa-info-circle",
        },
        // accessMenuFun(26) && {
        //   name: "Portin Check Status",
        //   path: "checkstatus/portin-check-status",
        //   icon: "fas fa-tasks",
        // },
      ].filter(Boolean),
    },
  ].filter(Boolean);



  return (
    <>
      <Fragment>
        <div className={`${styles.navbar_wrapper} fixed-top bg-white p-0 flex-column`}>
          <div
            className={`${styles.header_action} d-flex align-items-center justify-content-between h-fixed`}
          >
            <div
              className={styles.navbar_nav}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <div className={styles.logo_container}>
                <button type="button" onClick={() => setToggle(!toggle)}>
                  {toggle ? (
                    <i className="fa-solid fa-xmark"></i>
                  ) : (
                    <i className="fa-solid fa-bars"></i>
                  )}
                </button>
                <Link to="/">
                  <img className={styles.logo} src={logo} alt="logo" />
                  <img
                    className={styles.mini_logo}
                    src={mini_logo}
                    alt="logo"
                  />
                </Link>
              </div>
              <div
                className={styles.logo}
                style={{
                  padding: "7px 18px",
                  borderRadius: "20px",
                  marginLeft: "30px",
                  backgroundColor: "#d8e8dc",
                  color: "#c10ed8",
                  stifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <i className="ri-user-fill fs-6"></i> &nbsp;&nbsp;
                <span style={{ fontWeight: "600", fontSize: "14px" }}>
                  #{tokenData?.aCode}
                </span>{" "}
              </div>
            </div>

            <ul className={styles.social_item} ref={dropRef}>
              <li>
                <p className={styles.logo} style={{ color: "#810b90", fontWeight: "600", fontSize: "14px", }} > Account Balance:{" "} <span style={{ color: "#48985d", fontWeight: "800", fontSize: "15px", }} > {defaultCurrency} {twoDigitDecimal(tokenData?.accountBalance)} </span> </p>
              </li>
              <li>
                <button type="button" onClick={() => { setOpenNotification(!openNotification); setLogoutModal(false); }} className={`${styles.for_notification} head-button`} style={{ borderRadius: "5px", color: "#fff", margin: "0px 0px 0px 5px", boxShadow: "0px 3px 5px rgba(66, 66, 66, 0.59)", padding: "2px 8px", background: "#ffffff", }} >
                  <i className="ri-phone-fill"></i>
                </button>
                {!openNotification ? (
                  <DropdownMenu left="24px" right="24px">
                    <ContactDetails />
                  </DropdownMenu>
                ) : null}
              </li>

              <li>
                <button
                  type="button"
                  onClick={() => {
                    setResetModal(true);
                    setLogoutModal(false);
                    setOpenNotification(true);
                  }}
                  className={styles.for_message}
                  style={{
                    borderRadius: "5px",
                    color: "#fff",
                    margin: "0px 0px 0px 5px",
                    boxShadow: "0px 3px 5px rgba(66,66,66,.59)",
                    padding: "2px 8px",
                    background: "#ffffff",
                  }}
                >
                  <i className="ri-settings-3-line"></i>
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => {
                    setLogoutModal(prev => !prev);
                    setOpenNotification(true);
                  }}
                  className={styles.for_message}
                  style={{
                    borderRadius: "5px",
                    color: "#fff",
                    margin: "0px 0px 0px 5px",
                    boxShadow: "0px 3px 5px rgba(66, 66, 66, 0.59)",
                    padding: "2px 8px",
                    background: "#ffffff",
                  }}
                >
                  <i className="ri-shut-down-line " style={{ fontWeight: "600" }}></i>
                </button>

                {/* Logout Modal */}
                <Logout setLogoutModal={setLogoutModal} showlogoutModal={logoutModal} />
              </li>
            </ul>
            <ResetPassword onCloseModal={() => setResetModal(false)} showResetModal={resetModal} />
          </div>

          {/* Nav Items */}
          <div
            data-color={"black"}
            className={`${styles.duall_navbar} ${toggle ? styles.toggle_menu : ""
              }`}
          >
            <ul className={`${styles.nav}`}>
              {navItems?.map((item, index) => (
                <li
                  key={index}
                  className={`${styles.nav_item} ${item?.title ? "d-none" : ""}`}
                >
                  {(item?.path && (
                    <Fragment>
                      {isEmpty(item?.children) ? (<Link to={item?.path} {...(item?.target && { target: "_blank", })}
                        onClick={() => setNavIsOpen(navIsOpen === index ? null : index)} className="d-flex justify-content-between align-items-center" >
                        <div className="d-flex align-items-center gap-2">
                          <i className={`${item.icon} menu-icon`}></i>
                          <span>{item.name}</span>
                        </div>
                      </Link>
                      ) : (
                        <a onClick={() => setNavIsOpen(navIsOpen === index ? null : index)} className="d-flex justify-content-between align-items-center user-select-none " >
                          <div className="d-flex align-items-center gap-2">
                            <i className={`${item.icon} menu-icon`}></i>
                            <span>{item.name}</span>
                          </div>
                        </a>
                      )}
                    </Fragment>
                  )) ||
                    (item?.url && (
                      <a href={item?.url} target="_blank" className="d-flex align-items-center" >
                        <div className="d-flex align-items-center gap-2">
                          <i className={`${item.icon} menu-icon`}></i>
                          <span>{item.name}</span>
                        </div>
                      </a>
                    ))}
                  {item?.children ? (
                    <ul className={styles.sub_menu}>
                      {item?.children?.map((childItem, index) => (
                        <li key={index}>
                          <NavLink to={childItem?.path} onClick={() => setToggle(false)} className={({ isActive }) => `d-flex justify-content-between align-items-center ${isActive ? styles.activeSubMenu : ""}`} >
                            <div className="d-flex align-items-center gap-2">
                              <i className={`${childItem.icon} menu-icon`}></i>
                              <span>{childItem.name}</span>
                            </div>
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </Fragment>
    </>
  );
}

export default Header;
